import React, { useEffect, useState } from "react";
import { Typography, Slider, Grid, Box } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepThree(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    const marks = [
        {
            value: 0,
            label: 'Sans avis',
        },
        {
            value: 5,
            label: 'de temps en temps',
        },
        {
            value: 10,
            label: 'En majorité',
        }
    ];

    useEffect(() => {
        if (props.datas.lengthRent && Object.keys(props.datas.lengthRent).length >= 4) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        if(!datas.lengthRent){
            datas.lengthRent = {};
        }
        datas.lengthRent[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Selon vous, quelles sont les durées de séjours habituelles en «location de logements à court et moyen terme»?
            </Typography>
            <Grid container spacing={2} justifyContent='center' direction='row'>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        habituellement de 1 à 3 jours
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.lengthRent && props.datas.lengthRent['1-3d'] ? props.datas.lengthRent['1-3d'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='1-3d'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        habituellement de 3 à 6 jours
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.lengthRent && props.datas.lengthRent['3-6d'] ? props.datas.lengthRent['3-6d'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='3-6d'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        habituellement de 1 à 3 semaine
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.lengthRent && props.datas.lengthRent['1-3w'] ? props.datas.lengthRent['1-3w'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='1-3w'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={9} >
                    <Typography id="input-slider" textAlign='center' gutterBottom>
                        habituellement de 1 à plusieurs mois
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs>
                            <Slider
                                aria-label="Temperature"
                                defaultValue={props.datas.lengthRent && props.datas.lengthRent['1-*m'] ? props.datas.lengthRent['1-*m'] : 5}
                                valueLabelDisplay="auto"
                                step={1}
                                marks={marks}
                                min={0}
                                max={10}
                                name='1-*m'
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <ModalFooter buttons={buttons} />
        </>
    )
}